import type { PrintSettings, Template } from '../api/types';
import type { ContractTemplate } from '../contract/types';

function relTime(ts: number): string {
  const diff = Date.now() - ts;
  const m = Math.floor(diff / 60_000);
  if (m < 1) return '刚刚';
  if (m < 60) return `${m} 分钟前`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h} 小时前`;
  const d = Math.floor(h / 24);
  if (d < 30) return `${d} 天前`;
  return new Date(ts).toLocaleDateString('zh-CN');
}

function orientLabel(s: PrintSettings | { orientation: 'portrait' | 'landscape' }) {
  return s.orientation === 'portrait' ? '纵向' : '横向';
}

export function summarizeTableTemplate(t: Template): string {
  const o = orientLabel(t.settings);
  return `${t.fieldIds.length} 列 · ${t.settings.paperSize} ${o} · ${relTime(t.updatedAt)}`;
}

export function summarizeContractTemplate(t: ContractTemplate): string {
  const o = orientLabel(t.settings);
  return `${t.sections.length} 区块 · ${t.settings.paperSize} ${o} · ${relTime(t.updatedAt)}`;
}
